import * as angular from 'angular';

export class DevicesRequestsService {

  /* @ngInject */
  constructor(private DevicesAPI, private $devices) {
  }

  getDevices(agentId) {
    const api = this.DevicesAPI.actions.getDevices;
    return this.$$call(api, {agentId: agentId}, {}, {});
  }

// ******************************
// Internal methods
// ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$devices().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.devices')
  .service('devicesRequestsService', DevicesRequestsService);
